import { combineLatest, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import type { PlantlifeCardData } from '../../../../../../../../models/print-cards/plantlife-card-data';
import { map } from 'rxjs/operators';
import { CannabinoidOrTerpeneFromPool } from '../../../shared/card-data-with-property-pooling';
import { BadgeUtils } from '../../../../../../../../utils/badge-utils';
import { SectionLayoutType } from '../../../../../../../../models/enum/dto/section-layout-type.enum';
import { FilterUtils } from '../../../../../../../../utils/filter-utils';
import { PlantlifeBusinessCardStackSharedLogicContentViewModel } from '../plantlife-business-card-stack-shared-logic-content-view-model';

@Injectable()
export class PlantlifeBusinessCardStackContentViewModel extends PlantlifeBusinessCardStackSharedLogicContentViewModel {
  public override readonly cardData$: Observable<PlantlifeCardData>;

  public readonly topTerpene$ = this.cardData$.pipe(
    map(cardData => {
      return cardData?.getTopTerpene();
    })
  );

  public readonly isCurrentVariantOnSale$ = combineLatest([
    this.locationConfig$,
    this.cardData$,
    this.cardStackMenu$,
    this.cardStack$,
    this.spoofedColViewModel$
  ]).pipe(
    map(([locationConfig, cardData, menu, cardStack, colVm]) => {
      const priceStream = locationConfig?.priceFormat;
      const locationId = locationConfig?.locationId;
      return menu?.isVariantPriceDiscounted(priceStream, locationId, cardStack, cardData, colVm);
    })
  );

  public readonly filteredPoolingCompounds$: Observable<CannabinoidOrTerpeneFromPool[]> = combineLatest([
    this.propertiesBasedOnPools$,
    this.showSize$,
    this.isCurrentVariantOnSale$
  ]).pipe(
    map(([poolingCompounds, showSize, onSale]) => {
      return poolingCompounds.slice(0, Math.max(0, 5 - Number(showSize) - Number(onSale)));
    })
  );

  public readonly regularBadges$ = this.cardData$.pipe(
    map(data => {
      if (!data?.menu) return [];
      const limit = data?.menu?.getAllowedBadgeCount();
      const badges = BadgeUtils.getBadges(SectionLayoutType.List, limit, data.variantBadgeMap, data.rowVariants);
      return badges?.filter(badge => !FilterUtils.keepPlantLifeTaggedBadges(badge));
    })
  );

  public hasRegularBadges$ = this.regularBadges$.pipe(map(badges => badges?.length > 0));
}
